import React from "react";
// import styles from "./StylesForServices.module.css";
import Seo from "./../../Seo";

export default function LibreOfficeTraining() {
  return (
    <>
      <Seo
        title="LibreOffice od podstaw – kurs dla początkujących"
        description="Szkolenie z obsługi pakietu LibreOffice dla osób rozpoczynających pracę z komputerem. Poznaj Writer, Calc i Impress krok po kroku."
      />
      <section id="service" className="sectionContainer light">
        <div className="sectionTitle">
          <h2>Szkolenie LibreOffice</h2>
        </div>
      </section>
    </>
  );
}
